import { useMemo } from 'react';
import { Props as ReactApexChartProps } from 'react-apexcharts';
import { LangType } from '../../../../../../helpers/lang';
import { useLang } from '../../../../../../hooks/use-lang';
import { useDashboardStore } from '../../../../../../store/use-dashboard-store';
import { ChartProps } from '../../dashboard-components/dashboard-charts/use-dashboard-charts';

interface DataType {
  counts: number[];
  names: LangType[];
}

export const useTopNegativeLocations = (): ChartProps => {
  const { t, getLocale } = useLang();
  const { list } = useDashboardStore();
  const data = list?.qrs_with_negative_feedbacks as DataType;

  const chartData = useMemo<ReactApexChartProps>(() => {
    if (data) {
      return {
        series: data.counts.some((item) => item > 0)
          ? [{ name: t('Кол-во отзывов'), data: data.counts }]
          : [],
        options: {
          chart: {
            type: 'bar',
            zoom: { enabled: false },
            toolbar: {
              show: false,
            },
          },
          plotOptions: {
            bar: {
              barHeight: 8,
              borderRadius: 4,
              distributed: true,
              horizontal: true,
              colors: {
                backgroundBarColors: ['#F2F2F2'],
                backgroundBarRadius: 4,
              },
              dataLabels: {
                position: 'bottom',
                maxItems: 10,
              },
            },
          },
          legend: {
            show: false,
          },

          xaxis: {
            categories: data.names.map((name) => getLocale(name)),
            axisTicks: {
              show: false,
            },
            axisBorder: {
              show: false,
            },
            labels: {
              show: false,
            },
          },
          yaxis: [
            {
              show: false,
              axisBorder: {
                show: false,
              },
            },
          ],
          colors: ['#D80027'],
          dataLabels: {
            enabled: true,
            textAnchor: 'start',
            style: {
              colors: ['#000'],
              fontSize: '14px',
              fontWeight: 'normal',
            },
            formatter: function (val, opt) {
              return opt.w.globals.labels[opt.dataPointIndex] + ' (' + val + ')';
            },
            offsetY: -16,
            offsetX: -10,
          },
          grid: {
            show: false,
            padding: {
              left: -14,
              right: -14,
              bottom: -14,
              top: 10,
            },
          },

          annotations: {
            texts: [
              {
                text: t('Название локации'),
                fontSize: 12,
                x: 0,
                y: 20,
                textAnchor: 'start',
                borderColor: 'transparent',
                foreColor: '#828282',
                fontWeight: 400,
              },
            ],
          },
        },
      };
    }

    return {
      series: [],
      options: {},
    };
  }, [data, t]);

  return {
    label: 'QR с наибольшим количеством негативных отзывов',
    subLabel:
      'Диаграмма выделяет QR получившие больше всего негативных отзывов, помогая сконцентрироваться на ключевых точках улучшения',
    type: 'bar',
    ...chartData,
  };
};
